import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { nativeAppRoutePaths, routePath } from '../../constants/Routes';
import { UserEnrolledDevicesServiceResetState } from '../../store/UserEnrolledDevices/UserEnrolledDevicesSlice';
import { isDesktopOrBmcClient, trackGANativeApp } from '../../constants/AppMethod';
import { NativeAPP_GAEvents } from '../../constants/AppConstants';
 
const RouteListener = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const isNativeApp = isDesktopOrBmcClient();
 
    useEffect(() => {
        // Check if the route matches exactly (can customize with regex too)
        if (location.pathname === routePath.DASHBOARD ) {
            dispatch(UserEnrolledDevicesServiceResetState());
            if(isNativeApp){
                trackGANativeApp(NativeAPP_GAEvents.ECOPRO_DASHBOARD);
            }
        }
        if(location.pathname === nativeAppRoutePaths.BPLUS.DASHBOARD_PAGE){
            trackGANativeApp(NativeAPP_GAEvents.BPLUS_DASHBOARD);
        }
        // eslint-disable-next-line
    }, [location.pathname, dispatch]);
 
    return null;
};
 
export default RouteListener;